/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Dining = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4 8V7.94V2H5.5V7.94C5.5 9.20579 6.52421 10.23 7.79 10.23H8.3C9.54573 10.23 10.5575 9.238 10.5892 8H10.58V2H12.08V7.94H12.09C12.09 9.86817 10.6525 11.4586 8.78998 11.6987V21.98H7.28998V11.6974C5.45171 11.4554 4.02987 9.89762 4.00046 8H4ZM20.26 2.75V21.95H18.76V15.4H17.44C15.7989 15.4 14.516 13.9926 14.6526 12.3672L15.1926 5.96694L15.1928 5.96538C15.3861 3.72962 17.2589 2 19.51 2H20.26V2.75H20.26ZM7.28998 2V8.5H8.78998V2H7.28998ZM16.1473 12.4928L16.6872 6.09462C16.7918 4.88898 17.6426 3.90909 18.76 3.60113V13.9H17.44C16.6811 13.9 16.0841 13.2473 16.1473 12.4928Z"
                        fill={color}
                    />
                </svg>
        );
    };
